import React, { Suspense, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { useMediaQuery } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Button } from "react-bootstrap";
import LoaderInternal from "../../LoaderInternal";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import { fetchCruiseDetails } from "../../data/cruises/cruiseDetailsSlice";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { ru, ar, pt, es } from "date-fns/locale";
SwiperCore.use([Navigation, Pagination, Autoplay]);
const CruiseDetails = () => {
  const { t, i18n } = useTranslation();
  const getLocale = () => {
    switch (i18n.language) {
      case "ru":
        return ru;
      case "pt":
        return pt;
      case "es":
        return es;
      case "ar":
        return ar;
      default:
        return undefined; // Default to English if no match
    }
  };
  const { cruiseUrl } = useParams();
  const [showMore, setShowMore] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const language = useSelector((state) => state.language.language);
  const currency = useSelector((state) => state.currency.currency);
  const [destinationCruises, setDestinationCruises] = useState("");
  const [availableDates, setAvailableDates] = useState([]);
  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };
  const [ItineraryId, setItineraryId] = useState("");
  const [startDateCruises, setStartDateCruises] = useState();
  const [startDateCruisesMenu, setStartDateCruisesMenu] = useState();
  const [endDateCruisesMenu, setEndDateCruisesMenu] = useState();
  const [adultsCruises, setAdultsCruises] = useState(2);
  const [childrenCruises, setChildrenCruises] = useState(0);
  const [selectedOpid, setSelectedOpid] = useState(null);
  const { cruiseDetails, loading, error } = useSelector(
    (state) => state.cruiseDetails
  );
  const CruiseID = cruiseDetails.cruiseDetails?.cruiseId;
  const handleItineraryChange = async (e) => {
    const ItinerariesID = e.target.value;
    setItineraryId(ItinerariesID);

    try {
      const response = await axios.get(
        `https://api.travco.com/apiTITSol/TTG24_NileCruise/SelectIOperationDaysCruiseDetails?CruiseID=${CruiseID}&ItinerariesID=${ItinerariesID}`
      );
      const dates = response.data.map((date) => ({
        operationDate: new Date(date.operationDate),
        opid: date.opid,
      }));
      setAvailableDates(dates);
      setStartDateCruises(
        dates[0]?.operationDate,
        cruiseDetails.cruiseDetails?.cutOfDays
      );
      setStartDateCruisesMenu(
        dates[0]?.operationDate,
        cruiseDetails.cruiseDetails?.cutOfDays
      );
      setEndDateCruisesMenu(dates[dates.length - 1]?.operationDate || null);
      setSelectedOpid(dates[0]?.opid || null);
    } catch (error) {
      console.error("Error fetching dates: ", error);
    }
  };
  const handleDateChange = (date) => {
    setStartDateCruises(date);

    const selectedOperation = availableDates.find(
      (operation) => operation.operationDate.getTime() === date.getTime()
    );

    if (selectedOperation) {
      setSelectedOpid(selectedOperation.opid);
    } else {
      setSelectedOpid(null); // Ensure selectedOpid is reset if no match is found
    }
  };

  const isDateAvailable = (date) =>
    availableDates.some(
      (operation) => operation.operationDate.getTime() === date.getTime()
    );
  useEffect(() => {
    dispatch(fetchCruiseDetails({ cruiseUrl, currency, language }));
  }, [dispatch, cruiseUrl, currency, language]);

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("cruises_ItineraryId", ItineraryId);
    localStorage.setItem(
      "cruises_startDateCruises",
      formatDate(startDateCruises)
    );
    localStorage.setItem("cruises_adultsCruises", adultsCruises);
    localStorage.setItem("cruises_childrenCruises", childrenCruises);

    navigate(`/${cruiseUrl}/cabinsbooking/${selectedOpid}`);
  };
  const [activeTab, setActiveTab] = useState("rlr-product-sec-overview");
  const [showPopover, setShowPopover] = useState(false);

  const togglePopover = () => {
    setShowPopover(!showPopover);
  };
  // slider
  const [mainSplide, setMainSplide] = useState(null);
  const [thumbnailSplide, setThumbnailSplide] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(1);
  const [totalSlides, setTotalSlides] = useState(
    cruiseDetails.cruisePhotos?.length
  );

  useEffect(() => {
    if (mainSplide && thumbnailSplide) {
      // Update main carousel when a thumbnail is clicked
      thumbnailSplide.on("click", (slide) => {
        const index = slide.index;
        mainSplide.go(index); // Synchronize main carousel with thumbnail click
      });

      // Update currentIndex and totalSlides on main carousel change
      mainSplide.on("moved", () => {
        const index = mainSplide.index;
        setCurrentIndex(index + 1); // Splide uses zero-based index
        setTotalSlides(mainSplide.length);
      });
    }
  }, [mainSplide, thumbnailSplide]);
  // Effect to initialize Splide instances and synchronize them
  useEffect(() => {
    if (mainSplide && thumbnailSplide) {
      // Update main carousel when a thumbnail is clicked
      thumbnailSplide.on("click", (slide) => {
        const index = slide.index;
        mainSplide.go(index); // Synchronize main carousel with thumbnail click
      });
    }
  }, [mainSplide, thumbnailSplide]);

  // Main carousel options
  const mainOptions = {
    type: "loop",
    perPage: 1,
    pagination: false,
    height: isMobile ? "50" : "75vh",
    drag: true,
    gap: 10,
    updateOnMove: true,
  };

  // Thumbnail carousel options
  const thumbnailOptions = {
    fixedWidth: 180,
    fixedHeight: 122,
    isNavigation: false,
    focus: "center",
    pagination: false,
    direction: "ttb",
    height: "75vh",
    gap: 10,
  };

  // Format the date in the desired format
  const formatDateForDayName = (dateString) => {
    if (!dateString) return null;

    // Convert date string to JavaScript Date object
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) return dateString;

    // Format the date in the desired format
    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    return formattedDate;
  };
  const unescapeHtml = (html) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = html;
    return textArea.value;
  };

  return (
    <>
      <Helmet>
        <title>
          {cruiseDetails.pageDetails?.pageMetatagTitle || "Nile Cruises"}
        </title>

        <link
          rel="canonical"
          href={`https://travco.com/${language}/nile-cruises/${cruiseUrl}`}
          data-react-helmet="true"
        />
        <meta
          name="description"
          content={cruiseDetails.pageDetails?.pageMetatagDescription}
        />
        <meta
          property="og:title"
          content={cruiseDetails.pageDetails?.metatagTitleFacebook}
        />
        <meta
          property="og:description"
          content={cruiseDetails.pageDetails?.metatagDescriptionFacebook}
        />
        <meta
          name="twitter:title"
          content={cruiseDetails.pageDetails?.metatagTitleTwitter}
        />
        <meta
          name="twitter:description"
          content={cruiseDetails.pageDetails?.metatagDescriptionTwitter}
        />
        <style type="text/css">
          {`
          .react-datepicker-wrapper{
          width:100%
          }
          .react-datepicker__day, .react-datepicker__month-text, .react-datepicker__quarter-text, .react-datepicker__year-text{
          background-color:#ddd;
          border-radius:5px;
          }
          .react-datepicker__day--disabled, .react-datepicker__month-text--disabled, .react-datepicker__quarter-text--disabled, .react-datepicker__year-text--disabled{
          background-color:#fff;}

          `}
        </style>
      </Helmet>
      <section className="outter">
        <div
          id="rlr_banner_slider"
          className="splide rlr-banner-splide rlr-banner-splide--fullwidth-v2"
        >
          <div className="splide__track rlr-banner-splide__track">
            <ul className="splide__list height-internal-pages">
              <li className="splide__slide height-internal-pages rlr-banner-splide__slide">
                <div className="rlr-banner-splide__image-wrapper height-internal-pages">
                  <div className="overlay-banner"></div>
                  <Suspense fallback={<div>{t("Loading")}...</div>}>
                    <img
                      src={
                        isMobile
                          ? cruiseDetails.pageDetails?.pageBannerMobile
                          : isTablet
                          ? cruiseDetails.pageDetails?.pageBannerTablet
                          : cruiseDetails.pageDetails?.pageBannerPc
                      }
                      alt={cruiseDetails.pageDetails?.altBanner}
                      loading="lazy"
                    />
                  </Suspense>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="rlr-search-results-page__breadcrumb-section">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb rlr-breadcrumb__items">
              <li className="breadcrumb-item rlr-breadcrumb__item">
                <Link to="/">{t("Home")} </Link>
              </li>
              <li className="breadcrumb-item rlr-breadcrumb__item">
                <Link to="/nile-cruises">{t("Nile Cruises")}</Link>
              </li>

              <li
                className="breadcrumb-item rlr-breadcrumb__item active"
                aria-current="page"
              >
                {cruiseDetails.pageDetails?.pageTitle}
              </li>
            </ol>
          </nav>
          <div className="rlr-icon-text">
            <i className="rlr-icon-font flaticon-phone-receiver-silhouette">
              {" "}
            </i>{" "}
            <Link
              to="tel:(+202) 3854 1010"
              className="rlr-search-results-page__phone"
            >
              {t("Questions")}{" "}
              {language == "ar" ? (
                <>
                  ؟ <span style={{ direction: "ltr" }}> (+202) 3854 1010</span>
                </>
              ) : (
                "? (+202) 3854 1010"
              )}{" "}
            </Link>
          </div>
        </div>
      </div>
      {/* Slides  */}
      {loading ? (
        <LoaderInternal />
      ) : (
        <section className="py-5 mt-lg-5">
          <div className="container">
            <aside className="row">
              <div className="rlr-product-detail-header__contents d-flex justify-content-between px-3">
                <h1 className="rlr-section__heading--main rlr-product-detail-header__title rlr-section__title--main">
                  {cruiseDetails.pageDetails?.pageTitle}{" "}
                </h1>{" "}
                <div
                  className="rlr-product-detail-header d-inline-block "
                  id="rlr-js-detail-header"
                >
                  <div className="rlr-product-detail-header__actions">
                    <button
                      type="button"
                      onClick={togglePopover}
                      id="rlr-js-share-button"
                      className="btn rlr-button rlr-button--circle rlr-popover-button  "
                      aria-label="share"
                    >
                      <i className="rlr-icon-font flaticon-share-1"></i>
                    </button>
                    <div
                      id="rlr-js-share-popover"
                      className={`rlr-popover ${
                        showPopover
                          ? "rlr-popover--visible"
                          : "rlr-popover--hide"
                      }`}
                    >
                      <div className="rlr-share">
                        <div className="d-flex justify-content-between align-items-center">
                          {" "}
                          <h3 className="rlr-share__title mb-5">
                            {t("Share with a friend")}{" "}
                          </h3>
                          <Button
                            type="button"
                            onClick={togglePopover}
                            className="btn btn-danger d-block mb-5"
                            style={{ borderRadius: "50%" }}
                          >
                            <FontAwesomeIcon icon={faClose} />
                          </Button>
                        </div>
                        <ul className="rlr-share__items">
                          <li className="rlr-share__list rlr-js--facebook">
                            <a
                              target="_blank"
                              href={`https://ww.facebook.com/sharer/sharer.php?u=${window.location.href}`}
                              className="rlr-icon-text rlr-icon-text--anchor rlr-icon-text__block rlr-share__item"
                            >
                              <i className="rlr-icon-font flaticon-facebook"></i>
                              <span className="rlr-share__title">
                                {t("Facebook")}{" "}
                              </span>
                            </a>
                          </li>
                          <li className="rlr-share__list rlr-js--twitter">
                            <a
                              target="_blank"
                              href={`https://twitter.com/intent/tweet?text=${cruiseDetails.cruiseDetails?.pageTitle}&url=${window.location.href}`}
                              className="rlr-icon-text rlr-icon-text--anchor rlr-icon-text__block rlr-share__item social-links"
                            >
                              <span className="link twitter m-auto">
                                <span
                                  style={{
                                    margin: "auto",
                                    textAlign: "center",
                                    width: "35px",
                                    border: "2px solid #5c6770",
                                    height: "35px",
                                    padding: "5px",
                                    display: "flex",
                                    justifyContent: "center ",
                                  }}
                                ></span>
                              </span>
                              <span className="rlr-share__title">
                                {" "}
                                {t("Twitter")}{" "}
                              </span>
                            </a>
                          </li>
                          <li className="rlr-share__list rlr-js--whatsapp">
                            <a
                              target="_blank"
                              href={`https://api.whatsapp.com/send?text=${cruiseDetails.pageDetails?.pageTitle}%20${window.location.href}`}
                              className="rlr-icon-text rlr-icon-text--anchor rlr-icon-text__block rlr-share__item"
                            >
                              <i className="rlr-icon-font flaticon-whatsapp"></i>
                              <span className="rlr-share__title">
                                {t("Whatsapp")}{" "}
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {cruiseDetails.cruisePhotos?.length > 0 && (
                <div className="row mx-auto   justify-content-lg-between px-0">
                  <div
                    className="col-12 col-md-10 m-auto position-relative px-0"
                    style={{ boxShadow: "0 0 5px 2px #eee" }}
                  >
                    <Splide options={mainOptions} onMounted={setMainSplide}>
                      {cruiseDetails.cruisePhotos?.map((image, index) => (
                        <SplideSlide
                          key={index}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <img
                            src={image.photoFile}
                            alt={`Slide ${index}`}
                            loading="lazy"
                            style={{
                              width: "auto",
                              height: "auto",
                              borderRadius: ".5rem",
                            }}
                          />
                          <div className="rlr-media__custom-pagination rlr-js-custom-pagination">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.2 0C.542 0 0 .558 0 1.235v11.53C0 13.442.542 14 1.2 14h15.6c.658 0 1.2-.558 1.2-1.235V1.235C18 .558 17.458 0 16.8 0H1.2zm0 .824h15.6c.228 0 .4.176.4.411v9.844l-3.506-3.95a.4.4 0 0 0-.588 0l-2.862 3.126L6.1 5.488a.4.4 0 0 0-.362-.135.4.4 0 0 0-.232.129L.8 10.687V1.235C.8 1 .972.823 1.2.823zm9.2 2.058c-.879 0-1.6.743-1.6 1.647 0 .905.721 1.647 1.6 1.647.879 0 1.6-.742 1.6-1.647 0-.904-.721-1.647-1.6-1.647zm0 .824c.447 0 .8.363.8.823 0 .46-.353.824-.8.824a.806.806 0 0 1-.8-.824c0-.46.353-.823.8-.823zm-4.606 2.67 5.912 6.8H1.2a.397.397 0 0 1-.4-.411v-.869l4.994-5.52zm7.6 1.64 3.806 4.285v.464a.397.397 0 0 1-.4.411h-4.019l-2-2.303 2.613-2.856z"
                                fill="#212529"
                              ></path>
                            </svg>
                            <span className="rlr-media__page-counter rlr-js-page">
                              {index + 1} / {cruiseDetails.cruisePhotos?.length}
                            </span>
                          </div>
                        </SplideSlide>
                      ))}
                    </Splide>{" "}
                  </div>
                  {!isMobile && (
                    <div className="col-md-2">
                      <Splide
                        options={thumbnailOptions}
                        onMounted={setThumbnailSplide}
                      >
                        {cruiseDetails.cruisePhotos?.map((image, index) => (
                          <SplideSlide key={index}>
                            <img
                              src={image.photoFile}
                              alt={`Thumbnail ${index}`}
                              style={{
                                width: "100%",
                                height: "122px",
                                cursor: "pointer",
                                borderRadius: ".5rem",
                              }}
                              loading="lazy"
                            />
                          </SplideSlide>
                        ))}
                      </Splide>
                    </div>
                  )}
                </div>
              )}
            </aside>
          </div>
        </section>
      )}
      <section className="container d-flex  justify-content-between align-items-start flex-wrap rlr-product-detail-section pb-5">
        <div className="rlr-product-detail-section__details col-lg-8">
          <span id="rlr-product-sec-overview-section"></span>
          <nav className="rlr-product-detail-secondary-menu">
            <ul
              className="rlr-product-detail-secondary-menu__tabitems"
              id="rlr-js-secondary-menu"
            >
              <li
                className={`rlr-product-detail-secondary-menu__tabitem js-tabitem ${
                  activeTab === "rlr-product-sec-overview" ? "is-active" : ""
                }`}
                id="rlr-product-sec-overview"
                onClick={() => {
                  setActiveTab("rlr-product-sec-overview");
                  navigate("#rlr-product-sec-overview-section");
                }}
              >
                <span>{t("Overview")}</span>
              </li>
              <li
                className={`rlr-product-detail-secondary-menu__tabitem js-tabitem ${
                  activeTab === "rlr-product-sec-itinerary" ? "is-active" : ""
                }`}
                id="rlr-product-sec-itinerary"
                onClick={() => {
                  setActiveTab("rlr-product-sec-itinerary");
                  navigate("#rlr-product-sec-itinerary-section");
                }}
              >
                <span>{t("Itinerary")}</span>
              </li>
              <li
                className={`rlr-product-detail-secondary-menu__tabitem js-tabitem ${
                  activeTab === "rlr-product-sec-Included" ? "is-active" : ""
                }`}
                id="rlr-product-sec-Included"
                onClick={() => {
                  setActiveTab("rlr-product-sec-Included");
                  navigate("#rlr-product-sec-Included-section");
                }}
              >
                <span>{t("Included")}</span>
              </li>
              <li
                className={`rlr-product-detail-secondary-menu__tabitem js-tabitem ${
                  activeTab === "rlr-product-sec-Excluded" ? "is-active" : ""
                }`}
                id="rlr-product-sec-Excluded"
                onClick={() => {
                  setActiveTab("rlr-product-sec-Excluded");
                  navigate("#rlr-product-sec-Excluded-section");
                }}
              >
                <span>{t("Excluded")}</span>
              </li>
              <li
                className={`rlr-product-detail-secondary-menu__tabitem js-tabitem ${
                  activeTab === "rlr-product-sec-faq" ? "is-active" : ""
                }`}
                id="rlr-product-sec-faq"
                onClick={() => {
                  setActiveTab("rlr-product-sec-faq");
                  navigate("#rlr-product-sec-faq-section");
                }}
              >
                <span>{t("Policies")}</span>
              </li>
            </ul>
          </nav>

          {/* Overview */}

          <div
            className="rlr-secondary-menu-desc"
            data-id="rlr-product-sec-overview"
          >
            {!isMobile && (
              <div className="rlr-secondary-menu-desc__icon">
                <svg
                  width="41"
                  height="51"
                  viewBox="0 0 41 51"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M40.327 13.61H28.296c-.334 0-.558-.221-.558-.55l.002-11.852c0-.329.224-.55.558-.55.334 0 .558.221.558.55l-.002 11.304h11.473c.334 0 .558.22.558.55 0 .33-.224.547-.558.547z"
                    fill="#99A3AD"
                  ></path>
                  <path
                    d="M36.54 50.707H4.568C2.005 50.707 0 48.73 0 46.207L.002 5.047c0-2.525 2.005-4.5 4.568-4.5h23.728c.11 0 .334.109.445.109L40.885 12.51c.11.11.11.22.11.439v33.255c.113 2.527-1.892 4.503-4.455 4.503zM4.568 1.756c-1.892 0-3.342 1.428-3.342 3.292v41.158c0 1.867 1.56 3.402 3.453 3.402H36.65c1.894 0 3.453-1.537 3.453-3.402l.002-32.926-11.92-11.524H4.567z"
                    fill="#99A3AD"
                  ></path>
                  <path
                    d="M33.309 19.756h-19.27c-.335 0-.558-.22-.558-.55 0-.329.223-.549.557-.549h19.273c.334 0 .558.22.558.55-.002.329-.226.55-.56.55zM33.309 25.133H7.91c-.334 0-.558-.22-.558-.55 0-.328.224-.549.558-.549h25.399c.334 0 .558.22.558.55 0 .331-.224.55-.558.55zM33.309 30.622H7.91c-.334 0-.558-.22-.558-.55 0-.329.224-.55.558-.55h25.399c.334 0 .558.221.558.55 0 .33-.224.55-.558.55zM33.309 36.11H7.91c-.334 0-.558-.22-.558-.55 0-.329.224-.549.558-.549h25.399c.334 0 .558.22.558.55 0 .329-.224.55-.558.55zM33.309 41.487H7.91c-.334 0-.558-.22-.558-.549 0-.33.224-.55.558-.55h25.399c.334 0 .558.22.558.55 0 .33-.224.55-.558.55z"
                    fill="#99A3AD"
                  ></path>
                </svg>
              </div>
            )}
            <div className="rlr-secondary-menu-desc__details">
              <div className="rlr-overview-detail">
                <div className="rlr-readmore-desc rlr-overview-detail__description">
                  <h4 className="rlr-section__title--main">
                    {" "}
                    {isMobile && (
                      <div className="rlr-secondary-menu-desc__icon d-inline-block">
                        <svg
                          width="35"
                          height="35"
                          viewBox="0 0 41 51"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M40.327 13.61H28.296c-.334 0-.558-.221-.558-.55l.002-11.852c0-.329.224-.55.558-.55.334 0 .558.221.558.55l-.002 11.304h11.473c.334 0 .558.22.558.55 0 .33-.224.547-.558.547z"
                            fill="#99A3AD"
                          ></path>
                          <path
                            d="M36.54 50.707H4.568C2.005 50.707 0 48.73 0 46.207L.002 5.047c0-2.525 2.005-4.5 4.568-4.5h23.728c.11 0 .334.109.445.109L40.885 12.51c.11.11.11.22.11.439v33.255c.113 2.527-1.892 4.503-4.455 4.503zM4.568 1.756c-1.892 0-3.342 1.428-3.342 3.292v41.158c0 1.867 1.56 3.402 3.453 3.402H36.65c1.894 0 3.453-1.537 3.453-3.402l.002-32.926-11.92-11.524H4.567z"
                            fill="#99A3AD"
                          ></path>
                          <path
                            d="M33.309 19.756h-19.27c-.335 0-.558-.22-.558-.55 0-.329.223-.549.557-.549h19.273c.334 0 .558.22.558.55-.002.329-.226.55-.56.55zM33.309 25.133H7.91c-.334 0-.558-.22-.558-.55 0-.328.224-.549.558-.549h25.399c.334 0 .558.22.558.55 0 .331-.224.55-.558.55zM33.309 30.622H7.91c-.334 0-.558-.22-.558-.55 0-.329.224-.55.558-.55h25.399c.334 0 .558.221.558.55 0 .33-.224.55-.558.55zM33.309 36.11H7.91c-.334 0-.558-.22-.558-.55 0-.329.224-.549.558-.549h25.399c.334 0 .558.22.558.55 0 .329-.224.55-.558.55zM33.309 41.487H7.91c-.334 0-.558-.22-.558-.549 0-.33.224-.55.558-.55h25.399c.334 0 .558.22.558.55 0 .33-.224.55-.558.55z"
                            fill="#99A3AD"
                          ></path>
                        </svg>
                      </div>
                    )}{" "}
                    {t("Highlights")}
                  </h4>
                  <p
                    className="rlr-readmore-desc__content rlr-js-desc"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: !showMore && "3",
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: cruiseDetails.cruiseDetails?.cruiseIntro,
                    }}
                  />
                  {cruiseDetails.cruiseDetails?.cruiseIntro?.length > 300 ? (
                    <span
                      className="rlr-readmore-desc__readmore rlr-js-readmore is-more  "
                      onClick={() => setShowMore(!showMore)}
                    >
                      {showMore ? (
                        <Link to="#details">{t("Show Less")}...</Link>
                      ) : (
                        `${t("Show more")}...`
                      )}
                    </span>
                  ) : isMobile &&
                    cruiseDetails.cruiseDetails?.cruiseIntro?.length > 150 ? (
                    <span
                      className="rlr-readmore-desc__readmore rlr-js-readmore is-more  "
                      onClick={() => setShowMore(!showMore)}
                    >
                      {showMore ? (
                        <Link to="#details">{t("Show Less")}...</Link>
                      ) : (
                        `${t("Show more")}...`
                      )}
                    </span>
                  ) : (
                    ""
                  )}{" "}
                </div>

                <div className="rlr-overview-detail__icon-groupset">
                  <div className="rlr-overview-detail__icon-group">
                    <span className="rlr-overview-detail__label">
                      {t("Cabins Number")}{" "}
                    </span>
                    <div className="rlr-overview-detail__icons">
                      <figure className="rlr-icon-text">
                        <i className="rlr-icon-font flaticon-carbon-dashboard">
                          {" "}
                        </i>{" "}
                        <span className="">
                          {cruiseDetails.cruiseDetails?.cabinNumbers}{" "}
                          {t("Cabins")}
                        </span>
                      </figure>
                    </div>
                  </div>
                  <div className="rlr-overview-detail__icon-group">
                    <span className="rlr-overview-detail__label">
                      {t("Number of Decks")}{" "}
                    </span>
                    <div className="rlr-overview-detail__icons">
                      <figure className="rlr-icon-text">
                        <i className="rlr-icon-font flaticon-menu-2"> </i>{" "}
                        <span className="">
                          {cruiseDetails.cruiseDetails?.deckNumbers}{" "}
                          {t("Luxurious Decks")}{" "}
                        </span>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span id="rlr-product-sec-itinerary-section"></span>
          {/* Itinerary   */}
          <div
            className="rlr-secondary-menu-desc"
            data-id="rlr-product-sec-itinerary"
          >
            {!isMobile && (
              <div className="rlr-secondary-menu-desc__icon">
                <svg
                  width="43"
                  height="38"
                  viewBox="0 0 43 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M43 .442c0-.016-.008-.03-.01-.047-.002-.015.003-.031 0-.047-.003-.014-.013-.024-.018-.037a.372.372 0 0 0-.035-.082.41.41 0 0 0-.177-.172.409.409 0 0 0-.08-.031.397.397 0 0 0-.085-.017C42.581.007 42.568 0 42.553 0c-.018 0-.032.008-.049.01-.016.002-.031-.003-.047 0L28.519 3.04 14.577.01h-.007c-.015-.003-.033 0-.05-.002-.013 0-.024-.008-.039-.008-.013 0-.025.006-.037.008-.018 0-.037 0-.054.003h-.004L.35 3.06c-.013.003-.024.013-.037.017a.44.44 0 0 0-.152.082.389.389 0 0 0-.059.062.438.438 0 0 0-.046.068.459.459 0 0 0-.049.165c0 .014-.008.025-.008.04v34.063c0 .017.008.03.01.047s-.001.03.002.047c.004.016.013.028.018.043a.377.377 0 0 0 .08.141c.014.017.026.033.042.047.026.023.056.04.087.058.017.009.031.02.049.026a.448.448 0 0 0 .255.022l13.94-3.03 13.94 3.03c.032.008.064.011.095.011.005 0 .01-.003.014-.003a.432.432 0 0 0 .082-.008l14.036-3.05c.014-.002.024-.012.037-.017a.47.47 0 0 0 .152-.082.44.44 0 0 0 .056-.06.43.43 0 0 0 .049-.07.432.432 0 0 0 .03-.075.374.374 0 0 0 .018-.089c0-.014.008-.025.008-.04V.443zM.894 3.85 14.037.993v16.584a.446.446 0 0 0-.272.136.44.44 0 0 0 .032.625c.082.073.158.151.24.225v15.589L.894 37.008V3.85zM14.93 19.413c.275.273.544.544.785.792a.448.448 0 0 0 .63.011.44.44 0 0 0 .012-.625 48.965 48.965 0 0 0-1.427-1.407V.993l13.144 2.856v21.217c-.259.11-.517.208-.776.284a.44.44 0 0 0 .125.866.446.446 0 0 0 .126-.019c.174-.051.35-.113.525-.178v10.988l-13.144-2.856V19.413zm14.036 6.215a9.751 9.751 0 0 0 1.137-.678.44.44 0 0 0 .11-.616.448.448 0 0 0-.62-.11 9.369 9.369 0 0 1-.627.398V3.85L42.108.993v33.159l-13.143 2.855V25.628z"
                    fill="#99A3AD"
                  ></path>
                  <path
                    d="M5.452 26.484a26.968 26.968 0 0 1-.167-.966.445.445 0 0 0-.508-.37.442.442 0 0 0-.373.504c.055.352.105.634.147.857a2.365 2.365 0 0 0-1.848 2.297 2.37 2.37 0 0 0 2.378 2.358 2.37 2.37 0 0 0 2.378-2.358c-.001-1.174-.873-2.143-2.007-2.322zM5.08 30.28c-.82 0-1.487-.661-1.487-1.474S4.26 27.33 5.08 27.33c.82 0 1.486.662 1.486 1.475 0 .813-.667 1.474-1.486 1.474zM38.218 6.8l1.051-1.043a.44.44 0 0 0 0-.625.449.449 0 0 0-.63 0l-1.051 1.043-1.05-1.043a.449.449 0 0 0-.631 0 .44.44 0 0 0 0 .625L36.958 6.8l-1.051 1.043a.44.44 0 0 0 .316.755.45.45 0 0 0 .315-.13l.66-.656c.005.106.01.204.013.323.006.24.204.432.445.432h.012a.444.444 0 0 0 .434-.453l-.006-.185.542.539a.45.45 0 0 0 .631 0 .44.44 0 0 0 0-.626L38.22 6.8zM12.178 15.992c-.9-.55-1.764-.9-2.644-1.073a.441.441 0 1 0-.173.867c.773.152 1.542.466 2.35.959a.448.448 0 0 0 .613-.146.44.44 0 0 0-.146-.607zM4.551 23.348l.028-.001a.445.445 0 0 0 .418-.468 21.743 21.743 0 0 1-.042-1.335c0-.433.014-.869.048-1.3a.443.443 0 0 0-.41-.475c-.244-.032-.46.164-.479.406-.036.453-.05.913-.05 1.369 0 .47.015.938.043 1.388.014.235.21.416.444.416zM4.94 17.99a.447.447 0 0 0 .577-.254c.34-.877.834-1.479 1.47-1.788a.44.44 0 0 0 .202-.592.448.448 0 0 0-.596-.202c-.844.411-1.486 1.174-1.908 2.265a.439.439 0 0 0 .255.57zM18.24 21.53a.45.45 0 0 0-.63-.004.44.44 0 0 0-.003.626 27.948 27.948 0 0 0 2.017 1.868.444.444 0 0 0 .628-.057.44.44 0 0 0-.057-.623 27.215 27.215 0 0 1-1.954-1.81zM37.629 10.418a.443.443 0 0 0-.478.41c-.07.942-.19 1.822-.357 2.612a.442.442 0 0 0 .438.533c.206 0 .39-.143.435-.351.175-.828.301-1.746.374-2.729a.446.446 0 0 0-.412-.475zM36.584 15.69a.447.447 0 0 0-.594.209c-.051.105-.104.209-.16.311-.306.561-.686 1.257-1.138 2.015a.44.44 0 0 0 .157.606.45.45 0 0 0 .611-.155c.459-.77.845-1.476 1.155-2.045.062-.115.123-.232.18-.35a.44.44 0 0 0-.211-.59zM33.236 20.46a20.156 20.156 0 0 1-1.677 2.046.441.441 0 0 0 .326.745.446.446 0 0 0 .325-.14c.585-.62 1.174-1.339 1.75-2.137a.44.44 0 0 0-.102-.616.446.446 0 0 0-.622.101zM24.791 25.553a7.526 7.526 0 0 1-2.417-.754.446.446 0 0 0-.631.222.44.44 0 0 0 .21.558l.017.01c.904.448 1.816.731 2.712.842a.445.445 0 0 0 .498-.384.443.443 0 0 0-.389-.494z"
                    fill="#99A3AD"
                  ></path>
                </svg>
              </div>
            )}
            <div className="rlr-secondary-menu-desc__details">
              <div className="rlr-readmore-desc">
                <h4 className="rlr-section__title--main">
                  {" "}
                  {isMobile && (
                    <svg
                      width="35"
                      height="35"
                      viewBox="0 0 43 38"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="m-3"
                    >
                      <path
                        d="M43 .442c0-.016-.008-.03-.01-.047-.002-.015.003-.031 0-.047-.003-.014-.013-.024-.018-.037a.372.372 0 0 0-.035-.082.41.41 0 0 0-.177-.172.409.409 0 0 0-.08-.031.397.397 0 0 0-.085-.017C42.581.007 42.568 0 42.553 0c-.018 0-.032.008-.049.01-.016.002-.031-.003-.047 0L28.519 3.04 14.577.01h-.007c-.015-.003-.033 0-.05-.002-.013 0-.024-.008-.039-.008-.013 0-.025.006-.037.008-.018 0-.037 0-.054.003h-.004L.35 3.06c-.013.003-.024.013-.037.017a.44.44 0 0 0-.152.082.389.389 0 0 0-.059.062.438.438 0 0 0-.046.068.459.459 0 0 0-.049.165c0 .014-.008.025-.008.04v34.063c0 .017.008.03.01.047s-.001.03.002.047c.004.016.013.028.018.043a.377.377 0 0 0 .08.141c.014.017.026.033.042.047.026.023.056.04.087.058.017.009.031.02.049.026a.448.448 0 0 0 .255.022l13.94-3.03 13.94 3.03c.032.008.064.011.095.011.005 0 .01-.003.014-.003a.432.432 0 0 0 .082-.008l14.036-3.05c.014-.002.024-.012.037-.017a.47.47 0 0 0 .152-.082.44.44 0 0 0 .056-.06.43.43 0 0 0 .049-.07.432.432 0 0 0 .03-.075.374.374 0 0 0 .018-.089c0-.014.008-.025.008-.04V.443zM.894 3.85 14.037.993v16.584a.446.446 0 0 0-.272.136.44.44 0 0 0 .032.625c.082.073.158.151.24.225v15.589L.894 37.008V3.85zM14.93 19.413c.275.273.544.544.785.792a.448.448 0 0 0 .63.011.44.44 0 0 0 .012-.625 48.965 48.965 0 0 0-1.427-1.407V.993l13.144 2.856v21.217c-.259.11-.517.208-.776.284a.44.44 0 0 0 .125.866.446.446 0 0 0 .126-.019c.174-.051.35-.113.525-.178v10.988l-13.144-2.856V19.413zm14.036 6.215a9.751 9.751 0 0 0 1.137-.678.44.44 0 0 0 .11-.616.448.448 0 0 0-.62-.11 9.369 9.369 0 0 1-.627.398V3.85L42.108.993v33.159l-13.143 2.855V25.628z"
                        fill="#99A3AD"
                      ></path>
                      <path
                        d="M5.452 26.484a26.968 26.968 0 0 1-.167-.966.445.445 0 0 0-.508-.37.442.442 0 0 0-.373.504c.055.352.105.634.147.857a2.365 2.365 0 0 0-1.848 2.297 2.37 2.37 0 0 0 2.378 2.358 2.37 2.37 0 0 0 2.378-2.358c-.001-1.174-.873-2.143-2.007-2.322zM5.08 30.28c-.82 0-1.487-.661-1.487-1.474S4.26 27.33 5.08 27.33c.82 0 1.486.662 1.486 1.475 0 .813-.667 1.474-1.486 1.474zM38.218 6.8l1.051-1.043a.44.44 0 0 0 0-.625.449.449 0 0 0-.63 0l-1.051 1.043-1.05-1.043a.449.449 0 0 0-.631 0 .44.44 0 0 0 0 .625L36.958 6.8l-1.051 1.043a.44.44 0 0 0 .316.755.45.45 0 0 0 .315-.13l.66-.656c.005.106.01.204.013.323.006.24.204.432.445.432h.012a.444.444 0 0 0 .434-.453l-.006-.185.542.539a.45.45 0 0 0 .631 0 .44.44 0 0 0 0-.626L38.22 6.8zM12.178 15.992c-.9-.55-1.764-.9-2.644-1.073a.441.441 0 1 0-.173.867c.773.152 1.542.466 2.35.959a.448.448 0 0 0 .613-.146.44.44 0 0 0-.146-.607zM4.551 23.348l.028-.001a.445.445 0 0 0 .418-.468 21.743 21.743 0 0 1-.042-1.335c0-.433.014-.869.048-1.3a.443.443 0 0 0-.41-.475c-.244-.032-.46.164-.479.406-.036.453-.05.913-.05 1.369 0 .47.015.938.043 1.388.014.235.21.416.444.416zM4.94 17.99a.447.447 0 0 0 .577-.254c.34-.877.834-1.479 1.47-1.788a.44.44 0 0 0 .202-.592.448.448 0 0 0-.596-.202c-.844.411-1.486 1.174-1.908 2.265a.439.439 0 0 0 .255.57zM18.24 21.53a.45.45 0 0 0-.63-.004.44.44 0 0 0-.003.626 27.948 27.948 0 0 0 2.017 1.868.444.444 0 0 0 .628-.057.44.44 0 0 0-.057-.623 27.215 27.215 0 0 1-1.954-1.81zM37.629 10.418a.443.443 0 0 0-.478.41c-.07.942-.19 1.822-.357 2.612a.442.442 0 0 0 .438.533c.206 0 .39-.143.435-.351.175-.828.301-1.746.374-2.729a.446.446 0 0 0-.412-.475zM36.584 15.69a.447.447 0 0 0-.594.209c-.051.105-.104.209-.16.311-.306.561-.686 1.257-1.138 2.015a.44.44 0 0 0 .157.606.45.45 0 0 0 .611-.155c.459-.77.845-1.476 1.155-2.045.062-.115.123-.232.18-.35a.44.44 0 0 0-.211-.59zM33.236 20.46a20.156 20.156 0 0 1-1.677 2.046.441.441 0 0 0 .326.745.446.446 0 0 0 .325-.14c.585-.62 1.174-1.339 1.75-2.137a.44.44 0 0 0-.102-.616.446.446 0 0 0-.622.101zM24.791 25.553a7.526 7.526 0 0 1-2.417-.754.446.446 0 0 0-.631.222.44.44 0 0 0 .21.558l.017.01c.904.448 1.816.731 2.712.842a.445.445 0 0 0 .498-.384.443.443 0 0 0-.389-.494z"
                        fill="#99A3AD"
                      ></path>
                    </svg>
                  )}{" "}
                  {t("Itinerary")}
                </h4>
              </div>

              <div className="accordion rlr-accordion">
                {cruiseDetails.itinerariesDetails?.itineraries?.map(
                  (itinary, index) => (
                    <div
                      className="accordion-item rlr-accordion__item"
                      key={index}
                    >
                      <div
                        className="accordion-header rlr-accordion__header"
                        id="rlr-itinerary-header_1"
                      >
                        <button
                          // className="accordion-button rlr-accordion__button collapsed"
                          className="accordion-button rlr-accordion__button "
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#rlr-itinerary-collapse_${
                            index + 1
                          }`}
                          aria-expanded="true"
                          // aria-expanded="false"
                          aria-controls={`rlr-itinerary-collapse_${index + 1}`}
                        >
                          {/* <span className="rlr-accordion__badge">
                            {index + 1} 
                          </span>  */}
                          {itinary.itineraryNameSys}
                        </button>
                      </div>
                      <div
                        id={`rlr-itinerary-collapse_${index + 1}`}
                        className="accordion-collapse"
                        // className="accordion-collapse collapse"
                        aria-labelledby="rlr-itinerary-header_1"
                      >
                        {itinary.itineraryDays?.map((item, i) => (
                          <div
                            className="accordion-body rlr-accordion__body"
                            key={i}
                          >
                            <div className="rlr-readmore-desc">
                              <strong>
                                {t("Day")} {item.dayNumber} - {item.dayNameSys}
                              </strong>
                              <div
                                className="rlr-readmore-desc__content rlr-js-desc pt-2"
                                dangerouslySetInnerHTML={{
                                  __html: item.dayDetails,
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>

          <span id="rlr-product-sec-faq-section"></span>
          {/* Policies  */}
          <div
            className="rlr-secondary-menu-desc"
            data-id="rlr-product-sec-faq"
          >
            {!isMobile && (
              <div className="rlr-secondary-menu-desc__icon">
                <svg
                  width="52"
                  height="54"
                  viewBox="0 0 52 54"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M47.9971 40.8774C51.3711 35.5059 52.6762 29.0842 51.6677 22.8163C50.6593 16.5484 47.4065 10.8647 42.5192 6.8308C37.6319 2.79691 31.4458 0.689826 25.1205 0.904586C18.7953 1.11935 12.7653 3.6412 8.16107 7.99736C3.55685 12.3535 0.694579 18.2448 0.110868 24.5668C-0.472843 30.8887 1.26209 37.2072 4.99041 42.3376C8.71873 47.468 14.1844 51.0581 20.3627 52.4347C26.541 53.8113 33.0077 52.8799 38.5504 49.8151L49.3317 52.6147C49.6365 52.693 49.9567 52.6867 50.2582 52.5963C50.5596 52.506 50.8309 52.3351 51.0428 52.1019C51.2548 51.8687 51.3995 51.582 51.4614 51.2726C51.5234 50.9632 51.5002 50.6427 51.3944 50.3455L47.9971 40.8774ZM38.6544 48.0328C38.4348 47.9753 38.2014 48.0065 38.0044 48.1198C32.8405 51.0625 26.7801 52.0034 20.971 50.7642C15.162 49.525 10.0076 46.1917 6.48404 41.3957C2.96052 36.5996 1.31253 30.6739 1.85219 24.7406C2.39186 18.8074 5.08169 13.2787 9.41227 9.2016C13.7429 5.12451 19.4135 2.78212 25.3502 2.61806C31.2869 2.454 37.0775 4.47967 41.6252 8.31141C46.173 12.1432 49.1622 17.5149 50.0266 23.4094C50.891 29.3038 49.5707 35.3116 46.3158 40.2949C46.2423 40.4065 46.1955 40.5336 46.1789 40.6663C46.1624 40.799 46.1766 40.9337 46.2204 41.06L49.7651 50.9367L38.6544 48.0328Z"
                    fill="#99A3AD"
                  ></path>
                  <path
                    d="M25.5503 34.2444C24.8943 34.2199 24.2553 34.4575 23.7737 34.9051C23.5472 35.1221 23.3685 35.3843 23.2491 35.6748C23.1297 35.9652 23.0722 36.2775 23.0803 36.5916C23.0679 36.9042 23.1226 37.2158 23.2407 37.5053C23.3589 37.7947 23.5377 38.0554 23.765 38.2695C24.267 38.6903 24.9004 38.9209 25.5547 38.9209C26.2089 38.9209 26.8423 38.6903 27.3443 38.2695C27.5665 38.0555 27.7415 37.7972 27.858 37.5112C27.9744 37.2252 28.0297 36.9178 28.0203 36.609C28.0285 36.2949 27.971 35.9826 27.8516 35.6922C27.7322 35.4017 27.5535 35.1395 27.327 34.9225C27.0905 34.697 26.8116 34.5209 26.5066 34.4045C26.2016 34.288 25.8765 34.2336 25.5503 34.2444Z"
                    fill="#99A3AD"
                  ></path>
                  <path
                    d="M30.872 17.7334C29.4476 16.6114 27.6615 16.0543 25.854 16.1684C24.0226 16.0615 22.2183 16.6514 20.8014 17.8203C20.1747 18.3996 19.6812 19.1086 19.355 19.8983C19.0287 20.688 18.8776 21.5394 18.912 22.3935H23.332C23.3148 21.6853 23.5692 20.9976 24.0427 20.4721C24.2777 20.2352 24.5595 20.0502 24.8699 19.929C25.1803 19.8077 25.5126 19.7528 25.8453 19.7678C27.4313 19.7678 28.2287 20.6373 28.2287 22.3761C28.2256 22.9526 28.0668 23.5174 27.7693 24.0106C27.2536 24.7605 26.6351 25.4336 25.932 26.0103C25.117 26.6886 24.4678 27.5451 24.034 28.5142C23.6467 29.6069 23.4702 30.7635 23.514 31.9224H27.414L27.4747 30.9921C27.5919 29.9917 28.0623 29.0664 28.8007 28.3838L30.04 27.2014C30.854 26.4594 31.5393 25.5867 32.068 24.6192C32.4542 23.8572 32.6533 23.0136 32.6487 22.1587C32.6975 21.3352 32.5635 20.511 32.2562 19.7457C31.949 18.9804 31.4762 18.2931 30.872 17.7334V17.7334Z"
                    fill="#99A3AD"
                  ></path>
                </svg>
              </div>
            )}
            <div className="rlr-secondary-menu-desc__details">
              <h4 className="rlr-section__title--main ">
                {isMobile && (
                  <div className="rlr-secondary-menu-desc__icon d-inline  ">
                    <svg
                      width="52"
                      height="54"
                      viewBox="0 0 52 54"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M47.9971 40.8774C51.3711 35.5059 52.6762 29.0842 51.6677 22.8163C50.6593 16.5484 47.4065 10.8647 42.5192 6.8308C37.6319 2.79691 31.4458 0.689826 25.1205 0.904586C18.7953 1.11935 12.7653 3.6412 8.16107 7.99736C3.55685 12.3535 0.694579 18.2448 0.110868 24.5668C-0.472843 30.8887 1.26209 37.2072 4.99041 42.3376C8.71873 47.468 14.1844 51.0581 20.3627 52.4347C26.541 53.8113 33.0077 52.8799 38.5504 49.8151L49.3317 52.6147C49.6365 52.693 49.9567 52.6867 50.2582 52.5963C50.5596 52.506 50.8309 52.3351 51.0428 52.1019C51.2548 51.8687 51.3995 51.582 51.4614 51.2726C51.5234 50.9632 51.5002 50.6427 51.3944 50.3455L47.9971 40.8774ZM38.6544 48.0328C38.4348 47.9753 38.2014 48.0065 38.0044 48.1198C32.8405 51.0625 26.7801 52.0034 20.971 50.7642C15.162 49.525 10.0076 46.1917 6.48404 41.3957C2.96052 36.5996 1.31253 30.6739 1.85219 24.7406C2.39186 18.8074 5.08169 13.2787 9.41227 9.2016C13.7429 5.12451 19.4135 2.78212 25.3502 2.61806C31.2869 2.454 37.0775 4.47967 41.6252 8.31141C46.173 12.1432 49.1622 17.5149 50.0266 23.4094C50.891 29.3038 49.5707 35.3116 46.3158 40.2949C46.2423 40.4065 46.1955 40.5336 46.1789 40.6663C46.1624 40.799 46.1766 40.9337 46.2204 41.06L49.7651 50.9367L38.6544 48.0328Z"
                        fill="#99A3AD"
                      ></path>
                      <path
                        d="M25.5503 34.2444C24.8943 34.2199 24.2553 34.4575 23.7737 34.9051C23.5472 35.1221 23.3685 35.3843 23.2491 35.6748C23.1297 35.9652 23.0722 36.2775 23.0803 36.5916C23.0679 36.9042 23.1226 37.2158 23.2407 37.5053C23.3589 37.7947 23.5377 38.0554 23.765 38.2695C24.267 38.6903 24.9004 38.9209 25.5547 38.9209C26.2089 38.9209 26.8423 38.6903 27.3443 38.2695C27.5665 38.0555 27.7415 37.7972 27.858 37.5112C27.9744 37.2252 28.0297 36.9178 28.0203 36.609C28.0285 36.2949 27.971 35.9826 27.8516 35.6922C27.7322 35.4017 27.5535 35.1395 27.327 34.9225C27.0905 34.697 26.8116 34.5209 26.5066 34.4045C26.2016 34.288 25.8765 34.2336 25.5503 34.2444Z"
                        fill="#99A3AD"
                      ></path>
                      <path
                        d="M30.872 17.7334C29.4476 16.6114 27.6615 16.0543 25.854 16.1684C24.0226 16.0615 22.2183 16.6514 20.8014 17.8203C20.1747 18.3996 19.6812 19.1086 19.355 19.8983C19.0287 20.688 18.8776 21.5394 18.912 22.3935H23.332C23.3148 21.6853 23.5692 20.9976 24.0427 20.4721C24.2777 20.2352 24.5595 20.0502 24.8699 19.929C25.1803 19.8077 25.5126 19.7528 25.8453 19.7678C27.4313 19.7678 28.2287 20.6373 28.2287 22.3761C28.2256 22.9526 28.0668 23.5174 27.7693 24.0106C27.2536 24.7605 26.6351 25.4336 25.932 26.0103C25.117 26.6886 24.4678 27.5451 24.034 28.5142C23.6467 29.6069 23.4702 30.7635 23.514 31.9224H27.414L27.4747 30.9921C27.5919 29.9917 28.0623 29.0664 28.8007 28.3838L30.04 27.2014C30.854 26.4594 31.5393 25.5867 32.068 24.6192C32.4542 23.8572 32.6533 23.0136 32.6487 22.1587C32.6975 21.3352 32.5635 20.511 32.2562 19.7457C31.949 18.9804 31.4762 18.2931 30.872 17.7334V17.7334Z"
                        fill="#99A3AD"
                      ></path>
                    </svg>
                  </div>
                )}
                {t("Policies")}
              </h4>{" "}
              <div
                dangerouslySetInnerHTML={{
                  __html: cruiseDetails.cruiseDetails?.cruiseDetails,
                }}
              />
            </div>
          </div>

          <span id="rlr-product-sec-deckplan-section"></span>
          {/* DeckPlan  */}
          <div
            className="rlr-secondary-menu-desc"
            data-id="rlr-product-sec-deckplan"
          >
            {!isMobile && (
              <div className="rlr-secondary-menu-desc__icon">
                <div className="rlr-secondary-menu-desc__icon">
                  <img
                    src="images/Icons/icon-cruise-deckplan.png"
                    style={{ minWidth: "50px" }}
                    alt="DeckPlan icon"
                  />
                </div>
              </div>
            )}
            <div className="rlr-secondary-menu-desc__details">
              <h4 className="rlr-section__title--main mb-4">
                {isMobile && (
                  <div className="rlr-secondary-menu-desc__icon d-inline  ">
                    <img
                      src="images/Icons/icon-cruise-deckplan.png"
                      style={{ minWidth: "50px" }}
                      alt="DeckPlan icon"
                    />
                  </div>
                )}
                {t("Deckplan")}
              </h4>
              <div className="rlr-overview-detail__icon-groupset">
                <img
                  src={cruiseDetails.cruiseDetails?.cruiseDeckPlan}
                  alt="DeckPlan "
                />
              </div>
            </div>
          </div>
        </div>

        {/* Booking Engine  */}
        <aside
          className={`col-xl-3 rlr-search-results-page__sidebar view `}
          id="filter-mobile"
        >
          <div className="rlr-product-filters__filters-wrapper pb-5">
            <form onSubmit={handleSubmit}>
              <div className="row d-block nav-select d-lg-flex mb-lg-3   align-items-end">
                <div className="col-sm-12 col-lg-3dot6 col-xl-3gdot5 mb-3  ">
                  <span className="d-block text-gray-1 font-weight-normal text-left mb-0">
                    {t("Itinerary")}
                  </span>
                  <div className="d-flex align-items-center">
                    <i
                      className="icon flaticon-map-marker"
                      style={{ color: "#e60000" }}
                    >
                      {" "}
                    </i>
                    <select
                      id="TripTypeID"
                      name="TripTypeID"
                      className="form_control ps-1"
                      style={{
                        borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                        borderTop: "0px",
                        borderRight: "0px",
                        borderLeft: "0px",
                      }}
                      title="Itinerary"
                      value={ItineraryId}
                      onChange={handleItineraryChange}
                      required
                    >
                      <option hidden value="">
                        {t("Select Itinerary")}
                      </option>
                      <optgroup label="Nile Cruises">
                        {cruiseDetails.cruiseItineraries?.map((itinerary) => (
                          <option
                            value={itinerary.itineraryId}
                            key={itinerary.itineraryId}
                          >
                            {itinerary.itineraryNameSys}
                          </option>
                        ))}
                      </optgroup>
                    </select>
                  </div>
                </div>

                {/* Date Picker */}
                <div className="col-sm-12 col-lg-3dot6 col-xl-3gdot5 my-3 ">
                  <span className="d-block text-gray-1 font-weight-normal text-left mb-0">
                    {t("Date")}
                  </span>
                  <div className="border-bottom border-width-2 border-color-1">
                    <div
                      id="datepickerWrapperFromThree"
                      className="u-datepicker input-group d-flex align-items-center"
                    >
                      <div className="input-group-prepend">
                        <span className="d-flex align-items-center mr-2">
                          <i className="flaticon-calendar text-primary font-weight-semi-bold"></i>
                        </span>
                      </div>
                      <DatePicker
                        selected={startDateCruises}
                        onChange={handleDateChange}
                        className=" border-0 ps-1 py-3"
                        dateFormat="dd/MM/yyyy"
                        placeholderText="DD/MM/YYYY"
                        minDate={startDateCruisesMenu}
                        maxDate={endDateCruisesMenu}
                        filterDate={isDateAvailable}
                        title={
                          destinationCruises
                            ? ""
                            : "Select Your Itinerary Type And View Available Dates"
                        }
                        required
                        locale={getLocale()}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-lg-3 dot6 col-xl-3 gdot5 my-3  ">
                  <span className="d-block text-gray-1 font-weight-normal text-left mb-0">
                    {t("Adults")}
                  </span>
                  {/* Select */}
                  <div className="d-flex align-items-center">
                    <i className="rlr-icon-font flaticon-add-user text-primary "></i>
                    <select
                      id="AdultNo"
                      name="AdultNo"
                      className="form_control"
                      style={{
                        borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                        borderTop: "0px",
                        borderRight: "0px",
                        borderLeft: "0px",
                      }}
                      title={t("Adults")}
                      data-style=""
                      data-live-search="true"
                      data-searchbox-classes="input-group-sm"
                      value={adultsCruises}
                      onChange={(e) => setAdultsCruises(e.target.value)}
                    >
                      <option value="1"> 1 {t("Adult")}</option>
                      <option value="2" selected>
                        {" "}
                        2 {t("Adults")}
                      </option>
                    </select>
                  </div>
                  {/* End Select */}
                </div>
                <div className="col-sm-12 col-lg-3dot6 col-xl-3gdot5 mb-3">
                  <span className="d-block text-gray-1 font-weight-normal text-left mb-0">
                    {t("Child")}
                  </span>
                  {/* Select */}
                  <div className="d-flex align-items-center">
                    <i className="rlr-icon-font flaticon-add-user text-primary "></i>
                    <select
                      id="ChildNo"
                      name="ChildNo"
                      className="form_control"
                      style={{
                        borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                        borderTop: "0px",
                        borderRight: "0px",
                        borderLeft: "0px",
                      }}
                      title={t("Child")}
                      data-style=""
                      data-live-search="true"
                      data-searchbox-classes="input-group-sm"
                      value={childrenCruises}
                      onChange={(e) => setChildrenCruises(e.target.value)}
                    >
                      <option value="0" selected>
                        {" "}
                        0
                      </option>
                      <option value="1"> 1 {t("Child")}</option>
                      <option value="2"> 2 {t("Child")}</option>
                    </select>
                  </div>
                  {/* End Select */}
                </div>
                <div className="col-sm-12 ">
                  <button
                    type="submit"
                    className="btn btn-primary w-100 border-radius-3 mb-xl-0 mb-lg-1 transition-3d-hover"
                  >
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass}
                      className="mr-2"
                    />
                    {t("Search")}
                  </button>
                </div>
              </div>
              {/* End Checkbox */}
            </form>
          </div>
        </aside>
      </section>
    </>
  );
};

export default CruiseDetails;
